import { useEffect } from 'react';

import { captureException } from '../../../../services/sentryService';
import { PaymentMethod } from '../../../../types';

const useErrorLogger = (errorData: { paymentMethod: PaymentMethod; paymentId: string }) => {
  const { paymentMethod, paymentId } = errorData;
  useEffect(() => {
    if (!paymentId) {
      captureException({
        error: {
          message: `${paymentId}: was passed as payment Id`,
          name: 'payment id unknown',
        },
      });
    }
  }, [paymentId]);

  useEffect(() => {
    if (!paymentMethod) {
      captureException({
        error: {
          message: `${paymentMethod}: was passed as payment method`,
          name: 'payment method could not be identified',
        },
      });
    }
  }, [paymentMethod]);
};

export default useErrorLogger;
